import { Howl } from 'howler';
import detectPitch from 'detect-pitch';
import getUserMedia from 'get-user-media-promise';
import MicrophoneStream from 'microphone-stream';
import teoria from 'teoria';
import MicroModal from 'micromodal';
import Shepherd from 'shepherd.js';
import harmonica from './data';

import D3 from 'url:./mp3/D3.mp3';
import Ds3 from 'url:./mp3/Ds3.mp3';
import E3 from 'url:./mp3/E3.mp3';
import F3 from 'url:./mp3/F3.mp3';
import Fs3 from 'url:./mp3/Fs3.mp3';
import G3 from 'url:./mp3/G3.mp3';
import Gs3 from 'url:./mp3/Gs3.mp3';
import A3 from 'url:./mp3/A3.mp3';
import As3 from 'url:./mp3/As3.mp3';
import B3 from 'url:./mp3/B3.mp3';
import C4 from 'url:./mp3/C4.mp3';
import Cs4 from 'url:./mp3/Cs4.mp3';
import D4 from 'url:./mp3/D4.mp3';
import Ds4 from 'url:./mp3/Ds4.mp3';
import E4 from 'url:./mp3/E4.mp3';
import F4 from 'url:./mp3/F4.mp3';
import Fs4 from 'url:./mp3/Fs4.mp3';
import G4 from 'url:./mp3/G4.mp3';
import Gs4 from 'url:./mp3/Gs4.mp3';
import A4 from 'url:./mp3/A4.mp3';
import As4 from 'url:./mp3/As4.mp3';
import B4 from 'url:./mp3/B4.mp3';
import C5 from 'url:./mp3/C5.mp3';
import Cs5 from 'url:./mp3/Cs5.mp3';
import D5 from 'url:./mp3/D5.mp3';
import Ds5 from 'url:./mp3/Ds5.mp3';
import E5 from 'url:./mp3/E5.mp3';
import F5 from 'url:./mp3/F5.mp3';
import Fs5 from 'url:./mp3/Fs5.mp3';
import G5 from 'url:./mp3/G5.mp3';
import Gs5 from 'url:./mp3/Gs5.mp3';
import A5 from 'url:./mp3/A5.mp3';
import As5 from 'url:./mp3/As5.mp3';
import B5 from 'url:./mp3/B5.mp3';
import C6 from 'url:./mp3/C6.mp3';
import Cs6 from 'url:./mp3/Cs6.mp3';
import D6 from 'url:./mp3/D6.mp3';
import Ds6 from 'url:./mp3/Ds6.mp3';
import E6 from 'url:./mp3/E6.mp3';
import F6 from 'url:./mp3/F6.mp3';
import Fs6 from 'url:./mp3/Fs6.mp3';
import G6 from 'url:./mp3/G6.mp3';
import Gs6 from 'url:./mp3/Gs6.mp3';
import A6 from 'url:./mp3/A6.mp3';
import As6 from 'url:./mp3/As6.mp3';
import B6 from 'url:./mp3/B6.mp3';
import C7 from 'url:./mp3/C7.mp3';
import Cs7 from 'url:./mp3/Cs7.mp3';
import D7 from 'url:./mp3/D7.mp3';
import Ds7 from 'url:./mp3/Ds7.mp3';
import E7 from 'url:./mp3/E7.mp3';
import F7 from 'url:./mp3/F7.mp3';
import Fs7 from 'url:./mp3/Fs7.mp3';
import G7 from 'url:./mp3/G7.mp3';

const audioPaths = {
  D3,
  Ds3,
  E3,
  F3,
  Fs3,
  G3,
  Gs3,
  A3,
  As3,
  B3,
  C4,
  Cs4,
  D4,
  Ds4,
  E4,
  F4,
  Fs4,
  G4,
  Gs4,
  A4,
  As4,
  B4,
  C5,
  Cs5,
  D5,
  Ds5,
  E5,
  F5,
  Fs5,
  G5,
  Gs5,
  A5,
  As5,
  B5,
  C6,
  Cs6,
  D6,
  Ds6,
  E6,
  F6,
  Fs6,
  G6,
  Gs6,
  A6,
  As6,
  B6,
  C7,
  Cs7,
  D7,
  Ds7,
  E7,
  F7,
  Fs7,
  G7,
};

// Add enharmonic equivalents
audioPaths.Eb3 = Ds3;
audioPaths.Gb3 = Fs3;
audioPaths.Ab3 = Gs3;
audioPaths.Bb3 = As3;
audioPaths.Db4 = Cs4;
audioPaths.Eb4 = Ds4;
audioPaths.Gb4 = Fs4;
audioPaths.Ab4 = Gs4;
audioPaths.Bb4 = As4;
audioPaths.Db5 = Cs5;
audioPaths.Eb5 = Ds5;
audioPaths.Gb5 = Fs5;
audioPaths.Ab5 = Gs5;
audioPaths.Bb5 = As5;
audioPaths.Db6 = Cs6;
audioPaths.Eb6 = Ds6;
audioPaths.Gb6 = Fs6;
audioPaths.Ab6 = Gs6;
audioPaths.Bb6 = As6;
audioPaths.Db7 = Cs7;
audioPaths.Eb7 = Ds7;
audioPaths.Gb7 = Fs7;
// audioPaths.Ab7 = Gs7;
// audioPaths.Bb7 = As7;

var WindowAudioContext = window.AudioContext || window.webkitAudioContext;
var outputAudioContext;
var micAudioContext;
var listening = false;
var track;

var micButtonEl;
var micButtonStatusEl;
var keySelectEl;

var lineTimeout;
var noteStopTimeout;
var currentGainNode;
var visibilityHandler;
var volume = 0.6;

var defaultFormat = 'wave';
var format = 'wave';
var currentSoundPlaying;

function ready(fn) {
  function done() {
    document.removeEventListener('DOMContentLoaded', done);
    window.removeEventListener('load', done);
    fn();
  }

  if (document.readyState !== 'loading') {
    done();
  } else {
    document.addEventListener('DOMContentLoaded', done);
    window.addEventListener('load', done);
  }
}

const sounds = {};

ready(init);

function init() {
  loadAudio();
  setKey('C');
  setupKeySelect();
  setupFormat();
  setupAudio();
  setupMicButton();
  setupHelp();
}

function loadAudio() {
  Object.keys(audioPaths).forEach(function (note) {
    sounds[note] = new Howl({ src: [audioPaths[note]], volume: volume });
  });
}

// set up HTML based on key
function setKey(harmonicaKey) {
  var rows = harmonica[harmonicaKey];
  Object.keys(harmonica[harmonicaKey]).forEach(function (rowKey) {
    var selector =
      '.benditbetter-notes--' + camelToKebab(rowKey) + '> .benditbetter-note--on';
    var notesEls = document.querySelectorAll(selector);
    notesEls.forEach(function (noteEl, i) {
      // clear children
      while (noteEl.firstChild) {
        noteEl.removeChild(noteEl.firstChild);
      }

      var t = teoria.note(rows[rowKey][i]);
      noteEl.setAttribute('data-name', t.name());
      noteEl.setAttribute('data-accidental', t.accidental());
      noteEl.setAttribute('data-octave', t.octave());
      var noteTextEl = document.createElement('span');
      noteTextEl.setAttribute('class', 'benditbetter-note-text');
      noteTextEl.innerHTML = formatNote(
        t.name().toUpperCase() + t.accidental()
      );
      noteEl.appendChild(noteTextEl);
      var lineEl = document.createElement('div');
      lineEl.setAttribute('class', 'benditbetter-line');
      noteEl.appendChild(lineEl);
    });
  });
}

function setupAudio() {
  // http://marcgg.com/blog/2016/11/01/javascript-audio/
  if (WindowAudioContext) {
    outputAudioContext =
      (window.Howler && window.Howler.ctx) || new WindowAudioContext();
    micAudioContext = new WindowAudioContext();
    if (outputAudioContext) {
      // TODO: event delegation
      document
        .querySelectorAll('.benditbetter-note.benditbetter-note--on')
        .forEach(function (el) {
          el.addEventListener('click', function (e) {
            var noteEl = e.target.closest('.benditbetter-note');
            var noteString =
              noteEl.getAttribute('data-name').toUpperCase() +
              noteEl.getAttribute('data-accidental') +
              noteEl.getAttribute('data-octave');
            stopCurrentPlaying();
            play(noteString);
          });
        });
    }
  }
}

function play(noteString, short) {
  var note = teoria.note(noteString);
  var noteStringForFile = noteString.replace('#', 's');
  var sound = sounds[noteStringForFile];
  if (!sound) return;

  var shortDuration = 650;
  var fadeDuration = 150;
  var sampleDuration = sound.duration() * 1000;
  var fadeDelay = short ? shortDuration : sampleDuration - fadeDuration;

  if (format === 'wave') {
    var oscillatorNode = outputAudioContext.createOscillator();
    var gainNode = outputAudioContext.createGain();
    currentGainNode = gainNode;
    gainNode.gain.value = volume;
    oscillatorNode.connect(gainNode);
    gainNode.connect(outputAudioContext.destination);
    oscillatorNode.frequency.value = note.fq();
    oscillatorNode.start(0);
    noteStopTimeout = setTimeout(function () {
      gainNode.gain.exponentialRampToValueAtTime(
        0.00001,
        outputAudioContext.currentTime + 1
      );
    }, fadeDelay);
  } else if (format === 'sample') {
    var soundId = sound.play();
    currentSoundPlaying = sound;
    setTimeout(function () {
      sound.fade(volume, 0, fadeDuration, soundId);
    }, fadeDelay);
  }
}

function stopCurrentPlaying() {
  if (currentSoundPlaying) {
    currentSoundPlaying.stop();
  }
  if (noteStopTimeout) {
    clearTimeout(noteStopTimeout);
    if (currentGainNode) {
      currentGainNode.gain.exponentialRampToValueAtTime(
        0.00001,
        outputAudioContext.currentTime + 0.1
      );
    }
  }
}

function setupKeySelect() {
  micButtonEl = document.querySelector('.benditbetter-mic-button');
  micButtonStatusEl = document.querySelector('.benditbetter-mic-button__status');
  keySelectEl = document.querySelector('.benditbetter-select__select');
  keySelectEl.addEventListener('change', function () {
    if (keySelectEl.value) {
      setKey(keySelectEl.value);
    }
  });
}

function setupFormat() {
  if (window.localStorage) {
    var formatFromStorage =
      localStorage.getItem('BenditbetterFormat') || defaultFormat;
    if (formatFromStorage === 'wave') {
      document.querySelector('#input-wave').checked = true;
      format = 'wave';
    } else {
      document.querySelector('#input-sample').checked = true;
      format = 'sample';
    }
  }

  var formatRadioEls = document.querySelectorAll('.benditbetter-select__format input');
  function handleClick(e) {
    // TODO: stop all audio when switching formats
    stopCurrentPlaying();

    if (window.localStorage) {
      localStorage.setItem('BenditbetterFormat', e.target.value);
    }

    format = e.target.value;
    play('G4', true);
  }

  for (var i = 0; i < formatRadioEls.length; i++) {
    formatRadioEls[i].addEventListener('click', handleClick);
  }
}

var tour = new Shepherd.Tour({
  defaultStepOptions: {},
});
tour.addStep('mic', {
  text: 'Click the microphone button and start playing the harmonica. The notes that you play will appear on the notes below.',
  attachTo: '.benditbetter-mic-button right',
  buttons: [
    {
      action: tour.cancel,
      classes: 'shepherd-button-secondary',
      text: 'Exit',
    },
    {
      text: 'Next',
      action: tour.next,
    },
  ],
});
tour.addStep('pitch', {
  text: 'Click on the notes of the harmonica to hear the pitch.',
  attachTo: '.benditbetter-notes:nth-of-type(3) .benditbetter-note:nth-of-type(3) bottom',
  buttons: [
    {
      action: tour.cancel,
      classes: 'shepherd-button-secondary',
      text: 'Exit',
    },
    {
      text: 'Next',
      action: tour.next,
    },
  ],
});
tour.addStep('format', {
  text: 'Switch between harmonica samples and the sine wave audio format.',
  attachTo: '.switch-field label:last-of-type right',
  buttons: [
    {
      action: tour.cancel,
      classes: 'shepherd-button-secondary',
      text: 'Exit',
    },
    {
      text: 'Next',
      action: tour.next,
    },
  ],
});
tour.addStep('key', {
  text: 'Change the key of the harmonica here.',
  attachTo: '.benditbetter-select__select right',
  buttons: [
    {
      action: tour.cancel,
      classes: 'shepherd-button-secondary',
      text: 'Exit',
    },
    {
      text: 'Next',
      action: tour.next,
    },
  ],
});
tour.addStep('logo', {
  text: "Get more tips and help by clicking on the Harmonica.com logo here. Happy Harpin'!",
  attachTo: '.benditbetter-logo top',
  buttons: [
    {
      text: 'Done',
      action: tour.next,
    },
  ],
});

if (window.localStorage) {
  if (!localStorage.getItem('BenditbetterRepeatVisit')) {
    localStorage.setItem('BenditbetterRepeatVisit', true);
    tour.start();
  }
}

function setupHelp() {
  MicroModal.init({
    onClose: function () {
      document
        .querySelector('iframe')
        .contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          '*'
        );
    },
  });
  document
    .querySelector('.benditbetter-help__tour')
    .addEventListener('click', function () {
      tour.start();
    });
}

function setupMicButton() {
  // need user interaction on iOS
  micButtonEl.addEventListener('click', function () {
    stopCurrentPlaying();
    if (listening) {
      listening = false;
      if (track && track.enabled) {
        track.enabled = false;
      }
      micButtonEl.classList.remove('benditbetter-mic-button--listen');
      micButtonStatusEl.classList.remove('benditbetter-mic-button__status--on');
    } else {
      listenForMicrophone();
    }
  });

  // if not ios, and user has already granted mic permission, then auto click the mic button
  // if (!/iP(hone|od|ad)/.test(navigator.platform) && window.localStorage && localStorage.getItem('BenditbetterPermission') === 'true') {
  //     micButtonEl.click();
  // }
}

function listenForMicrophone() {
  if (getUserMedia.isSupported && WindowAudioContext) {
    var micStream = new MicrophoneStream({ bufferSize: 4096 });
    getUserMedia({ audio: true })
      .then(function (mediaStream) {
        listening = true;
        micButtonEl.classList.add('benditbetter-mic-button--listen');
        micButtonStatusEl.classList.add('benditbetter-mic-button__status--on');
        // if (window.localStorage) {
        //     localStorage.setItem('BenditbetterPermission', true);
        // }

        var tracks = mediaStream.getAudioTracks();
        track = tracks[0] || {};
        micStream.setStream(mediaStream);

        // disable media stream when page is hidden
        if (visibilityHandler) {
          document.removeEventListener('visibilitychange', visibilityHandler);
        }
        visibilityHandler = function () {
          if (listening) {
            track.enabled = !document.hidden;
          }
        };
        document.addEventListener('visibilitychange', visibilityHandler, false);

        micStream.on('data', function (chunk) {
          var raw = MicrophoneStream.toRaw(chunk); // Float32Array
          var periodInSamples = detectPitch(raw, 0.85);
          var sampleRateInHz = micAudioContext.sampleRate || 48000;
          var pitchInHz = sampleRateInHz / periodInSamples;
          if (periodInSamples !== 0) {
            updateFromMic(pitchInHz);
          }
        });
      })
      .catch(function (e) {
        // TODO: tell user permission was denied
        if (e) {
          // if (window.localStorage) {
          //     localStorage.setItem('BenditbetterPermission', false);
          // }
        }
      });
  } else {
    // TODO: tell user mic is not supported in their browser
  }
}

function updateFromMic(freq) {
  var noteData = teoria.note.fromFrequency(freq);
  var note = noteData.note;
  var cents = noteData.cents.toFixed(2);

  cents = cents > 0 ? Math.floor(cents) : Math.ceil(cents); // round towards zero

  // var div = document.getElementsByClassName('benditbetter-big')[0];
  // div.innerHTML = note.name().toUpperCase() + note.accidental() + note.octave() + '&nbsp;&middot;&nbsp;' + cents;

  var selector =
    '.benditbetter-note--on[data-name="' +
    note.name() +
    '"][data-accidental="' +
    note.accidental() +
    '"][data-octave="' +
    note.octave() +
    '"] > .benditbetter-line';
  var enharmonic = note.enharmonics(true)[0];
  if (enharmonic) {
    selector +=
      ', .benditbetter-note--on[data-name="' +
      enharmonic.name() +
      '"][data-accidental="' +
      enharmonic.accidental() +
      '"][data-octave="' +
      enharmonic.octave() +
      '"] > .benditbetter-line';
  }

  var lineEls = document.querySelectorAll(selector);
  if (lineEls.length) {
    clearTimeout(lineTimeout);
    lineTimeout = setTimeout(clear, 350);
    clear();

    lineEls.forEach(function (lineEl) {
      lineEl.classList.remove('benditbetter-line--close', 'benditbetter-line--correct');
      lineEl.classList.add('benditbetter-line--on');
      if (Math.abs(cents) < 8) {
        lineEl.classList.add('benditbetter-line--correct');
      } else if (Math.abs(cents) < 18) {
        lineEl.classList.add('benditbetter-line--close');
      }

      lineEl.style.top = -1 * (50 + cents) + '%';
    });
  }
}

function clear() {
  document.querySelectorAll('.benditbetter-line--on').forEach(function (lineEl) {
    lineEl.classList.remove('benditbetter-line--on');
  });
}

function camelToKebab(s) {
  return s.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

function formatNote(s) {
  return s
    .replace('b', '<span class="benditbetter-flat">&flat;</span>')
    .replace('#', '<span class="benditbetter-sharp">&sharp;</span>');
}
